<template>
  <BreadCrumb PageTitle=" Modifier une facture" />
    <EditFacture />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditFacture from "@/components/Facture/EditFacture.vue";
  
    export default defineComponent({
      name: "EditFacturePage",
      components: {
        BreadCrumb,
        EditFacture,
      },
    });
  </script>